export default {
    title: "",
    unavailable: "Dit product is niet meer leverbaar."
}